<template>
  <div class="info-container" @mouseleave="turnOffPreview">
  <!-- <div class="info-container"> -->
    <button @click="togglePreview" class="visit-profile tooltip_container">
      <IconBase
        icon-name="profile"
        iconColor="#bbb"
        viewBox="0 0 24 24"
        width="100%"
        height="100%"
        strokeWidth="2px"
        ><IconInfo
      /></IconBase>
      <ProfilePreview v-if="previewVisible && partner" :partner="partner" />
      <div
        class="tooltip tooltip--top tooltip--middle"
        v-show="!previewVisible"
      >
        <span class="tooltip_tip">Preview profile</span>
      </div>
    </button>
  </div>
</template>

<script>
import IconBase from "../../../../components/IconBase";
import IconInfo from "../../../../components/SVG/IconInfo";
import ProfilePreview from "./ProfilePreview";

export default {
  name: "PreviewButton",
  props: {
    partner: Object,
  },
  data() {
    return {
      previewVisible: false,
    };
  },
  components: {
    IconBase,
    IconInfo,
    ProfilePreview,
  },
  methods: {
    togglePreview() {
      this.previewVisible = !this.previewVisible;
      
      window.mixpanel.track("Preview Profile", {
        profileID: this.partner.metadata.ID,
        profileDisplayName: this.partner.metadata.displayName,
      });
      //   if (this.previewVisible) {
      //     this.turnOffPreview();
      //   } else {
      //     this.previewVisible = true;
      //     setTimeout(this.turnOffPreview, 10000);
      //   }
    },
    turnOffPreview() {
      this.previewVisible = false;
    },
  },
};
</script>





<style scoped>
.info-container {
  position: absolute;
  right: 6px;
  left: unset;
}
.visit-profile:hover .profilePreview {
  /* display: flex; */
  transition: 0.2s ease-in-out;
}
.tooltip {
  background: #2d2d2d;
  display: var(--tooltip-display);
  border-radius: 4px;
  color: white;
  filter: var(--tooltip-filter, none);
  flex-direction: row;
  flex-shrink: 0;
  font-weight: normal;
  font-size: 12px;
  padding: 6px 12px;
  position: absolute;
  text-align: center;
  transform: translate(var(--translateX, 0), var(--translateY, 0));
  white-space: nowrap;
  z-index: 900;
}
.tooltip::before {
  background: #2d2d2d;
  display: block;
  position: absolute;
  content: "";
  height: 8px;
  width: 8px;
  z-index: 1;
}
.tooltip--top {
  --translateY: calc(-100% - 8px);
  top: -4px;
}
.tooltip--top::before {
  bottom: 0;
  transform: rotate(45deg) translate(-50%, 50%);
  transform-origin: left bottom;
}
.tooltip--top.tooltip--middle {
  --translateX: -50%;
  left: 50%;
}
.tooltip--top.tooltip--middle::before {
  left: 50%;
}
.tooltip_container {
  --tooltip-display: none;
  position: relative;
}
@media (hover: hover) {
  .tooltip_container:hover {
    --tooltip-display: flex;
  }
}
</style>